import { lazy } from 'react';

export const LazyAdminPage = lazy(
  () =>
    import(/* webpackChunkName: "hellospa--page--admin-page" */ './admin-page'),
);
